import React from 'react';
import styles from '../../articleTileGrid/article-tile-grid.scss';
import IPfArticleTileGridProps from './pfArticleTileGrid.d'
import PfArticleTile from '../pfArticleTile/pfArticleTile';
import PfNoResult from '../pfNoResult/pfNoResult';

function PfArticleTileGrid(props: IPfArticleTileGridProps) {
    const {
        scoredProducts, l10n, finderType, isMobile,
        isGlobal, priceMode, gridRef
    } = props;
    const [priceModeState, setPriceModeState] = React.useState(priceMode);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            window.shell.subscribeTo(
                'PriceModeChanged',
                (newPriceMode) => setPriceModeState(newPriceMode),
                'ArticleTileService'
            );
        }
    }, []);

    return (
        <>
            {scoredProducts && scoredProducts.length > 0 ?
                <div ref={gridRef} className={styles.article_tile_grid_root}>
                    {
                        scoredProducts.map((product, index) => {
                            return (
                                <PfArticleTile
                                    key={index + product.salesArticleNo}
                                    product={product}
                                    isMobile={isMobile}
                                    isGlobal={isGlobal}
                                    l10n={l10n}
                                    priceMode={priceModeState}
                                    finderType={finderType}
                                />
                            );
                        })
                    }
                </div>
                : <PfNoResult l10n={l10n} finderType={finderType}/>
            }
        </>
    );
}

export default PfArticleTileGrid;
